var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrinidadAndTobago(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_7312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.616 28.426C115.698 40.255 94.185 55.76 74.973 74.972C55.76 94.185 40.255 115.698 28.427 138.616L193.034 318.965L373.383 483.572C396.302 471.743 417.815 456.238 437.027 437.027C456.24 417.814 471.744 396.301 483.573 373.383L318.966 193.033L138.616 28.426Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.027 437.027C447.766 426.288 457.344 414.829 465.776 402.81L109.191 46.2241C97.172 54.6551 85.713 64.2331 74.974 74.9721C64.235 85.7111 54.657 97.1701 46.225 109.19L402.81 465.774C414.828 457.343 426.288 447.766 437.027 437.027Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.972 437.027C155.739 517.794 277.036 533.298 373.382 483.572L28.427 138.616C-21.298 234.962 -5.79095 356.26 74.972 437.027V437.027Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.027 74.973C356.26 -5.79304 234.963 -21.297 138.617 28.426L483.572 373.384C533.298 277.038 517.794 155.739 437.027 74.973V74.973Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_7312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrinidadAndTobago);
export default __webpack_public_path__ + "static/media/trinidadAndTobago.d371074d245b72aa1a3fd2fb7083c394.svg";
export { ForwardRef as ReactComponent };